import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M760-609v-82q39 8 80.5 17t86.5 21l-93 493H127L34-653q44-12 85-21t81-17v82q-22 5-41 8.5t-33 6.5l67 354h574l67-354q-14-3-33-6.5t-41-8.5m-79 111-66-44 13-21q6-9 9-18.5t3-20.5q0-14-5-27t-15-23q-21-21-32.5-48.5T576-758q0-23 6.5-44t18.5-40l13-20 67 44-14 21q-6 9-8.5 18.5T656-758q0 14 5 27t15 23q21 21 32.5 48.5T720-602q0 23-6.5 44T695-518zm-168 0-66-44 13-21q6-9 9-18.5t3-20.5q0-14-5-27t-15-23q-21-21-32.5-48.5T408-758q0-23 6.5-44t18.5-40l13-20 67 44-14 21q-6 9-8.5 18.5T488-758q0 14 5 27t15 23q21 21 32.5 48.5T552-602q0 23-6.5 44T527-518zm-167 0-67-44 14-21q6-9 9-18.5t3-20.5q0-14-5.5-27T284-652q-21-21-32.5-48.5T240-758q0-23 6-44t19-40l14-20 67 44-14 21q-6 8-9 18t-3 21q0 14 5 27t15 23q21 21 32.5 48.5T384-602q0 23-6.5 44T359-518z"
    }, null, -1)
  ]))]))
}
export default { render: render }